jQuery( function ( $ ) {
	// URLパラメーターにdistanceが存在する場合、選択状態を更新
	const urlParams = new URLSearchParams(window.location.search);
	if (urlParams.has('distance')) {
		const distanceParamValue = urlParams.get('distance');
		$('select[name="distance"]').val(distanceParamValue);
	}

	// セレクトボックスの変更イベントを監視
	$('select[name="distance"]').change(function() {
		const distanceValue = $(this).val(); // 選択された値を取得
		let currentUrl = new URL(window.location.href); // 現在のURLを取得

		// distanceパラメーターの存在をチェック
		if (currentUrl.searchParams.has('distance')) {
		// distanceパラメーターがすでに存在する場合
		currentUrl.searchParams.set('distance', distanceValue); // 値を変更
		} else {
		// distanceパラメーターが存在しない場合
		currentUrl.searchParams.append('distance', distanceValue); // distanceパラメーターを追加
		}

		window.location.href = currentUrl.href;
	});
} );

